<div class="main-content" id="main-content">
   <section id="breadcrumbs">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div class="br-breadcrumb">
                  <ul class="crumb-list">
                     <li class="crumb home">
                        <a class="br-button circle" [routerLink]="['/']">
                           <span class="sr-only">Página inicial</span>
                           <i class="fas fa-home"></i>
                        </a>
                     </li>
                     <li class="crumb" data-active="active">
                        <i class="icon fas fa-chevron-right"></i>
                        <span>Apresentação</span>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>

   <section id="page">
      <div class="container-lg">
         <!-- <hr class="bg-color-dark-grey hr-line" /> -->
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <h2 *ngIf="catalogo" tabindex="0">Apresentação</h2>
               <!-- Apresentação -->
               <div
                  tabindex="0"
                  [innerHTML]="apresentacao | textToLink | formatText"
               ></div>

               <!-- Histórico-->
               <h3>Histórico das Edições do Catálogo</h3>
               <p>
                  Evolução do Catálogo Nacional de Cursos Superiores de
                  Tecnologia (CNCST).
               </p>

               <div id="timeline">
                  <div class="wizard">
                     <div
                        class="br-wizard"
                        collapsed="collapsed"
                        [attr.step]="catalogos.length"
                     >
                        <div class="wizard-progress" role="tablist">
                           <button
                              *ngFor="let catalogo of catalogos; let i = index"
                              class="wizard-progress-btn"
                              type="button"
                              [attr.step]="i + 1"
                              [attr.aria-labelledby]="'info' + (i + 1)"
                              role="tab"
                              [attr.aria-controls]="'tab' + (i + 1)"
                              [attr.title]="
                                 catalogo.id + 'ª Edição - ' + catalogo.ano
                              "
                              [attr.active]="
                                 catalogoSelecionado.id === i + 1
                                    ? 'active'
                                    : undefined
                              "
                              (click)="selecionaEdicao(i + 1)"
                           >
                              <span class="info" [id]="'info' + (i + 1)"
                                 >{{ catalogo.id }}ª Edição<br />
                                 <small>{{ catalogo.ano }}</small>
                              </span>
                           </button>
                        </div>

                        <div class="wizard-form">
                           <div
                              class="wizard-panel"
                              active="active"
                              role="tabpanel"
                              id="tab1"
                           >
                              <div class="wizard-panel-content" tabindex="0">
                                 <div class="text">
                                    <p class="edition">
                                       {{ catalogoSelecionado.id }}ª Edição
                                    </p>
                                    <!-- Erro de responsividade, caso texto de evolução seja grande-->
                                    <p class="caption">
                                       + {{ catalogoSelecionado.evolucao }}
                                    </p>
                                    <p class="year">
                                       {{ catalogoSelecionado.ano }}
                                    </p>

                                    <div class="br-magic-button">
                                       <a
                                          *ngIf="catalogoSelecionado.id !== 4"
                                          [href]="
                                             baseUrlCatalogo +
                                             catalogoSelecionado.nome
                                          "
                                          target="_blank"
                                          rel="noreferrer"
                                          class="br-button"
                                          type="button"
                                          aria-label="Mais Informações"
                                          href="#"
                                          >Mais Informações</a
                                       >
                                    </div>

                                    <div class="br-magic-button">
                                       <a
                                          *ngIf="catalogoSelecionado.id === 4"
                                          routerLink="{{
                                             catalogoSelecionado.url
                                          }}"
                                          target="_blank"
                                          rel="noreferrer"
                                          class="br-button"
                                          type="button"
                                          aria-label="Navegue pelos cursos"
                                          href="#"
                                          >Navegue pelos cursos</a
                                       >
                                    </div>
                                 </div>
                              </div>
                              <div class="wizard-panel-btn">
                                 <button
                                    class="br-button primary wizard-btn-next"
                                    type="button"
                                    aria-description=""
                                    (click)="irParaProximo()"
                                    [attr.disabled]="
                                       catalogoSelecionado.id + 1 > ultimaEdicao
                                          ? true
                                          : null
                                    "
                                 >
                                    Avançar
                                 </button>
                                 <button
                                    class="br-button secondary wizard-btn-prev"
                                    type="button"
                                    aria-description=""
                                    (click)="irParaAnterior()"
                                    [attr.disabled]="
                                       catalogoSelecionado.id - 1 < 1
                                          ? true
                                          : null
                                    "
                                 >
                                    Voltar
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
